import { toast } from '@doxyme/ui/components';
import { useIntl } from '@doxyme/locale';

export const useEndCallNotification = () => {
  const { formatMessage } = useIntl();

  return () =>
    toast.info({
      title: formatMessage({ id: 'callEnded' }),
    });
};
